import { useLocation } from 'react-router-dom';
import AllRecipes from '../components/AllRecipes';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function FilteredRecipes() {
  const query = useQuery();

  const initialFilters = {
    portionSize: query.get('portionSize') || '',
    cuisine: query.get('cuisine') || '',
    highProtein: query.get('highProtein') === 'true',
    vegan: query.get('vegan') || 'all',
    maxCalories: query.get('maxCalories') || '',
    difficulty: query.get('difficulty') || '',
    prepTime: query.get('prepTime') || ''
  };

  return (
    <div className="container_">
      <div className="py-8">
        <AllRecipes initialFilters={initialFilters} showFilterPanel={true} layout="grid" />
      </div>
    </div>
  );
}
